<template>
  <div class="container w-full min-h-full bg-cover relative flex flex-col justify-center">
    <HomeNavigation />

    <div class="items-container w-full h-full pt-60 laptop:pt-40 laptop:pl-60 laptop:pr-60 flex-1">
      <div class="max-w-1224 w-full h-full flex flex-col mx-auto laptop:flex-row">
        <div class="w-full flex laptop:w-2/3">
          <div class="w-full h-full flex flex-col text-white
          px-30 py-30 laptop:px-0">
            <div class="w-full mb-40">
              <img
                src="/images/autodrop/logo.svg"
                alt="AutoDrop"
                class="w-full max-h-50 object-left object-contain"
              >
            </div>
            <div class="flex flex-col justify-between">
              <!--Text-->
              <div>
                <div class="mb-40">
                  <h1 class="text-2xl">{{ $t('home_view.b2b_title_text') }}</h1>
                  <p class="mt-30 mb-30 w-full laptop:pr-10 laptop:w-3/4">
                    {{ $t('home_view.subtitle_long_text') }}
                  </p>
                  <p class="mt-30">{{ $t('home_view.subtitle_short_text') }}</p>
                </div>
                <h2 class="text-4xl text-primary mb-20">
                  {{ $t('home_view.advantages_text') }}
                </h2>
                <div class="flex flex-col mb-60 laptop:flex-row">
                  <div class="flex flex-row items-center w-full mb-10 laptop:mb-0 laptop:w-1/3">
                    <IconFA
                      :icon="['far', 'angle-right']"
                      fixed-width
                      class="icon text-3xl text-primary"
                    />
                    <p>{{ $t('home_view.first_advantage_text') }}</p>
                  </div>
                  <div class="flex flex-row items-center w-full mb-10 laptop:mb-0 laptop:w-1/3">
                    <IconFA
                      :icon="['far', 'angle-right']"
                      fixed-width
                      class="icon text-3xl text-primary"
                    />
                    <p>{{ $t('home_view.second_advantage_text') }}</p>
                  </div>
                  <div class="flex flex-row items-center w-full mb-10 laptop:mb-0 laptop:w-1/3">
                    <IconFA
                      :icon="['far', 'angle-right']"
                      fixed-width
                      class="icon text-3xl text-primary"
                    />
                    <p>{{ $t('home_view.third_advantage_text') }}</p>
                  </div>
                </div>
              </div>
              <!--Cards-->
              <div>
                <div class="flex-col w-full flex tablet:flex-row">
                  <RouterLink
                    :to="{ name: $t('home_view.read_more_route_name') }"
                    class="w-full flex flex-col justify-between text-secondary-dark py-18 px-25 mb-20 bg-white rounded
                    tablet:mr-15 tablet:mb-0"
                  >
                    <span>
                      <span class="font-bold text-xl leading-tight block mb-10 laptop:text-2xl">
                        {{ $t('home_view.sell_vehicle_title_text') }}
                      </span>
                      <span class="block text-sm leading-tight mb-20 laptop:text-base">
                        {{ $t('home_view.sell_vehicle_subtitle_text') }}
                      </span>
                    </span>
                    <span class="flex items-center justify-end">
                      <span class="text-primary italic font-bold text-right mr-10 laptop:mr-12">
                        {{ $t('home_view.read_more_text') }}
                      </span>
                      <IconFA
                        :icon="['fas', 'arrow-right']"
                        class="text-primary"
                      />
                    </span>
                  </RouterLink>
                  <RouterLink
                    :to="{ name: 'BuyerInformation' }"
                    class="w-full flex flex-col justify-between text-secondary-dark py-18 px-25 mb-20 bg-white rounded
                    tablet:ml-15 tablet:mb-0"
                  >
                    <span>
                      <span class="font-bold text-xl leading-tight block mb-10 laptop:text-2xl">
                        {{ $t('home_view.buy_vehicle_title_text') }}
                      </span>
                      <span class="block text-sm leading-tight mb-20 laptop:text-base">
                        {{ $t('home_view.buy_vehicle_subtitle_text') }}
                      </span>
                    </span>
                    <span class="flex items-center justify-end">
                      <span class="text-primary italic font-bold text-right mr-10 laptop:mr-12">
                        {{ $t('home_view.read_more_text') }}
                      </span>
                      <IconFA
                        :icon="['fas', 'arrow-right']"
                        class="text-primary"
                      />
                    </span>
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full p-30 flex items-end laptop:w-1/3 laptop:pt-30 laptop:pb-30 laptop:pl-30 laptop:pr-0">
          <div class="w-full bg-primary flex flex-col rounded py-20 px-25 laptop:max-w-400">
            <!--Contact form-->
            <form
              class="h-full flex flex-col justify-between"
              @submit.prevent="onFormSubmission"
            >
              <div v-if="!isEmailSent">
                <p class="text-xl text-white mb-20 laptop:text-2xl">
                  {{ $t('home_view.contact_form_title_text') }}
                </p>
              </div>
              <div
                v-if="isEmailSending && !isEmailSent"
                class="flex justify-center"
              >
                <UILoader class="text-white" />
              </div>
              <div
                v-if="isEmailSent"
                class="h-full flex flex-col items-center justify-center text-white text-center text-xl"
              >
                <p class="mb-40">{{ $t('home_view.thanks_for_email_text') }}</p>
                <IconFA
                  :icon="['far', 'check']"
                  fixed-width
                  class="icon text-3xl text-success"
                />
              </div>

              <div v-if="!isEmailSending">
                <fieldset class="mb-10">
                  <legend class="text-white mb-5">
                    {{ $t('home_view.i_want_to_text') }}
                  </legend>
                  <!-- <label class="flex items-center text-white mb-5 cursor-pointer">
                    <UIInputCheckbox
                      v-model="isBuyer"
                      class="mr-15"
                      @change="applyCheckBox"
                    />
                    {{ $t('home_view.i_want_to_buy_vehicle_text') }}
                  </label> -->
                  <label class="flex items-center text-white cursor-pointer">
                    <UIInputCheckbox
                      v-model="isSeller"
                      class="mr-15"
                      @change="applyCheckBox"
                      :value="true"
                    />
                    {{ $t('home_view.i_want_to_sell_vehicle_text') }}
                  </label>
                  <p
                    v-if="!selectedCheckBox && isPressSubmit"
                    class="text-sm font-medium pt-5 text-white"
                  >
                    {{ $t('home_view.choose_checkbox') }}
                  </p>
                  <p class="text-sm font-medium pt-5 text-white">
                    {{ $t('home_view.i_want_to_buy_vehicle_new_text') }}
                    <a
                      :href="`/app/${$i18n.locale}/sign-in?userType=buyer`"
                      class="underline hover:cursor-pointer"
                    >
                      {{ $t('home_view.i_want_to_buy_vehicle_new_link_text') }}
                    </a>
                  </p>
                </fieldset>
                <UIInputTextWithValidation
                  v-model="name"
                  :rules="nameRules"
                  :placeholder="$t('home_view.name_placeholder_text')"
                  class="mb-15"
                  error-text-color="text-white"
                >
                  <span class="text-white">
                    {{ $t('home_view.name_label_text') }}
                  </span>
                </UIInputTextWithValidation>
                <UIInputTextWithValidation
                  v-model="companyName"
                  :rules="nameRules"
                  :placeholder="$t('home_view.company_name_placeholder_text')"
                  class="mb-15"
                  error-text-color="text-white"
                >
                  <span class="text-white">
                    {{ $t('home_view.company_name_label_text') }}
                  </span>
                </UIInputTextWithValidation>
                <UIPhoneInput
                  v-model="phone"
                  type="tel"
                  :placeholder="$t('home_view.phone_placeholder_text')"
                  class="mb-10"
                  error-text-color="text-white"
                  :default-country="'CH'"
                  :countries="phoneCountries"
                  :flag-width="'20px'"
                  :show-flags="true"
                  :setValidPhoneNumber="setValidPhoneNumber"
                  :setValidCountry="setValidCountry"
                  >
                    <template #label>
                      <span class="flex flex-col justify-between mb-5 text-white mobile-l:flex-row
                      mobile-l:items-end">
                        <span class="leading-tight mr-20">
                          {{ $t('home_view.phone_label_text') }}
                        </span>
                        <span class="text-sm italic leading-tight pb-2 mobile-l:text-right">
                          {{ $t('home_view.phone_second_label_text') }}
                        </span>
                      </span>
                    </template>
                    <template #icon="{}">
                      <Transition name="fade-in-linear">
                        <IconFA
                          v-if="isPressSubmit && isInputPhone && isValidPhoneNumber"
                          :icon="['far', 'check']"
                          size="lg"
                          class="icon fa-fw absolute right-10 top-1/2 transform -translate-y-1/2 text-success"
                        />
                      </Transition>
                    </template>
                    <template #validation="{}">
                      <div v-if="isPressSubmit && !( isInputPhone && isValidPhoneNumber && isValidCountry )" class="invalidPhone">
                        <p
                          class="text-sm font-medium pt-5 text-white"
                        >
                          {{ $t('home_view.enter_valid_phone_text') }}
                        </p>
                      </div>
                    </template>
                </UIPhoneInput>
                <UIInputTextWithValidation
                  v-model="email"
                  type="email"
                  :rules="emailRules"
                  :placeholder="$t('home_view.email_placeholder_text')"
                  class="mb-50"
                  error-text-color="text-white"
                >
                  <span class="text-white">
                    {{ $t('home_view.email_label_text') }}
                  </span>
                </UIInputTextWithValidation>
              </div>
              <div>
                <button
                  v-if="!isEmailSending"
                  class="h-45 w-full bg-primary text-white p-10 border-2 border-white rounded
                  hover:bg-failure"
                  type="submit"
                >
                  {{ $t('home_view.send_email_button_text') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        v-show="publicVehicleListFiltered.length"
        class="max-w-1224 mt-40 mx-auto"
      >
        <h2 class="text-white text-center px-20 tablet:text-left laptop:px-0">
          {{ $t('home_view.last_offers_text') }}
        </h2>
        <ul
          class="grid-vehicle-list justify-center px-20 mt-20 mb-40 laptop:px-0
          tablet:justify-start"
        >
          <a
            v-for="(vehicle) in publicVehicleListFiltered"
            :key="`vehicle-${vehicle.id}`"
            :href="`/app/${$i18n.locale}/sign-in?tab=forBuyer`"
            class="grid-vehicle-card rounded overflow-hidden hover:cursor-pointer"
          >
            <div class="relative">

              <div
                class="absolute text-white px-10 py-8 flex items-center bottom-0">
                <IconFA
                  :icon="['far', 'info-circle']"
                  class="text-2xl"
                />
                <span class="ml-10 text-sm leading-tight">Details</span>
              </div>

              <img
                v-if="vehicle.mainImageSrc"
                :src="vehicle.mainImageSrc"
                :alt="`Fahrzeug ${vehicle.id}`"
                class="h-full w-full object-cover"
              >
              <div
                v-else
                class="h-full w-full bg-secondary-dark"
              ></div>
            </div>
            <ul class="p-20 bg-white">
              <li>
                {{ vehicle.fuel }}
              </li>
              <li>
                {{ vehicle.gearbox }}
              </li>
              <li>
                <span class="font-bold">{{ vehicle.mileage.toLocaleString('de-CH') }}</span> Km
              </li>
            </ul>
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
import { FBStorageRef } from '@/helpers/firebase/services';
import { getVehicles, getVehicleFiltersOfType } from '@/helpers/firebase/firestoreRefs';
import userTypes from '@/helpers/userTypes';
import vehicleTypes from '@/helpers/vehicleTypes';
import { APIAddEmailAddress } from '@/api';
import UIPhoneInput from '@/components/UI/UIPhoneInput';
import UIInputTextWithValidation from '@/components/UI-old/input/UIInputTextWithValidation';
import UIInputCheckbox from '@/components/UI/input/UIInputCheckbox';
import UILoader from '@/components/UI/UILoader';
import HomeNavigation from '@/components/HomeNavigation';


const maxVehiclesOnListing = 12;
const listingThreshold = 12;

export default {
  components: {
    UIInputTextWithValidation,
    UIInputCheckbox,
    UILoader,
    HomeNavigation,
    UIPhoneInput,
  },
  data() {
    return {
      // routerLinksNames: {
      //   sellerInformation: 'SellerInformationEN'
      // },
      showAvailableLanguages: false,
      isBuyer: false,
      isSeller: true,
      name: '',
      companyName: '',
      phone: '',
      email: '',
      countryCode: '',
      isPressSubmit: false,
      isInputPhone: false,
      isValidPhoneNumber: false,
      isValidCountry: false,
      selectedCheckBox: 1,
      // isErrorNumber: '',
      isEmailSending: false,
      isEmailSent: false,
      formValidationMessage: '',
      publicVehicleList: [],
      carFilters: null,
      nameRules: [{
        errorTextKey: this.$t('home_view.enter_valid_name_text'),
        validationFunction(value) {
          const re = /[A-Za-z]/;

          return re.test(value) && value.length <= 256;
        },
        trigger: 'submit',
      }],
      phoneRules: [{
        errorTextKey: this.$t('home_view.enter_valid_phone_text'),
        validationFunction(value) {
          const re = /^[\d ()+-]+$/;

          return re.test(value);
        },
        trigger: 'submit',
      }],
      emailRules: [{
        errorTextKey: this.$t('home_view.enter_valid_email_text'),
        validationFunction(value) {
          const re = /^.+@.+\..+$/;

          return value !== '' && re.test(value) && value.length <= 256;
        },
        trigger: 'submit',
      }],
      unsubPublicVehicleListing: null,
      unsubVehicleFilters: null,
    };
  },
  created() {
    // Pre-selecting contact form user type
    const preSelectType = this.$route?.params?.preSelectType;
    if (preSelectType === userTypes.BUYER) {
      this.isBuyer = true;
    } else if (preSelectType === userTypes.SELLER) {
      this.isSeller = true;
    }

    // Get the vehicleFilters for 'car' type
    this.unsubVehicleFilters = getVehicleFiltersOfType(vehicleTypes.CAR)
      .onSnapshot((snapshot) => {
        const vehicleFilters = {};

        snapshot.forEach((document) => {
          vehicleFilters[document.id] = document.data().options;
        });

        this.$set(this, 'carFilters', vehicleFilters);
      }, (error) => {
        console.error(error);
      });

    this.unsubPublicVehicleListing = this.subPublicVehicleListing();
  },
  updated() {
    // if (this.$i18n.locale == 'fr') {
    //   this.routerLinksNames = {
    //     sellerInformation: 'SellerInformationFR'
    //   };
    // } else if (this.$i18n.locale == 'en') {
    //   this.routerLinksNames = {
    //     sellerInformation: 'SellerInformationEN'
    //   };
    // } else if (this.$i18n.locale == 'de'){
    //   this.routerLinksNames = {
    //     sellerInformation: 'SellerInformationDE'
    //   };
    // }
  },
  computed: {
    publicVehicleListFiltered() {
      if (!this.carFilters) return [];

      return this.publicVehicleList.map((vehicle) => {
        const vehicleFuelType = this.carFilters.fuelType
          .find((opt) => opt.value === vehicle.fuelType);
        const vehicleGearboxType = this.carFilters.gearboxType
          .find((opt) => opt.value === vehicle.gearboxType);

        return {
          id: vehicle.id,
          fuel: vehicleFuelType[this.$i18n.locale]?.name,
          gearbox: vehicleGearboxType[this.$i18n.locale]?.name,
          mileage: vehicle.mileage,
          mainImageSrc: vehicle.mainImageSrc,
        };
      });
    },
    phoneCountries() {
      const countries = [
        { countryCode: 'CH', countryName: 'CH', prefix: '+41' },
        { countryCode: 'DE', countryName: 'DE', prefix: '+49' },
      ];
      if (process.env.NODE_ENV === 'development') {
        countries.push(
          { countryCode: 'BY', countryName: 'BY', prefix: '+375' },
          { countryCode: 'LT', countryName: 'LT', prefix: '+370' },
        );
      }
      return countries;
    },
  },
  methods: {
    applyCheckBox(data) {
      this.selectedCheckBox = data ? this.selectedCheckBox + 1 : this.selectedCheckBox - 1;
    },
    setValidPhoneNumber(data) {
      this.isValidPhoneNumber = data;
    },
    setValidCountry(data) {
      this.isValidCountry = data;
    },
    async validateFormInputs() {
      this.isPressSubmit = true;
      const inputValidators = [];

      this.$children.forEach((child) => {
        if (child.validateInput !== undefined) {
          inputValidators.push(child.validateInput());
        }
        if (Object.prototype.hasOwnProperty.call(child, 'isValidNumber')) {
          this.isInputPhone = !!child.value.length;

          inputValidators.push(this.isValidCountry && this.isValidPhoneNumber && child.value.length
            ? Promise.resolve() : Promise.reject());
        }
      });
      inputValidators.push(this.selectedCheckBox ? Promise.resolve() : Promise.reject());

      return Promise.all(inputValidators)
        .then(() => Promise.resolve())
        .catch(() => Promise.reject());
    },
    async onFormSubmission() {
      this.formValidationMessage = '';

      try {
        await this.validateFormInputs();
        this.isEmailSending = true;

        APIAddEmailAddress(this.name, this.companyName, this.phone, this.countryCode, this.email,
          this.isBuyer, this.isSeller).then((response) => {
          if (response.status === 200) {
            this.isEmailSent = true;
          }
        });
      } catch (error) {
        if (!error || !error.message) return;
        console.error(error);
        this.formValidationMessage = 'Server error';
      }
    },
    subPublicVehicleListing() {
      return getVehicles()
        .where('type', '==', vehicleTypes.CAR)
        .where('status', 'in', [1, 3])
        .orderBy('createdTime', 'desc')
        .limit(maxVehiclesOnListing + listingThreshold)
        .onSnapshot((snapshot) => {
          const publicVehicleList = [];
          let vehicleI = 0;

          snapshot.docs.forEach((vehicleDoc) => {
            const vehicleDocData = vehicleDoc.data();

            if (vehicleI >= maxVehiclesOnListing) return;

            if (!vehicleDocData?.noPublicListing) {
              vehicleI += 1;
              try {
                FBStorageRef
                  .child(vehicleDocData?.data?.thumbnailStoragePaths[0])
                  .getDownloadURL()
                  .then((URL) => {
                    const vehicleIndex = this.publicVehicleList
                      .findIndex((vehicle) => vehicle.id === vehicleDoc.id);
                    this.publicVehicleList[vehicleIndex].mainImageSrc = URL;
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              } catch (error) {
                console.error(error);
              }

              publicVehicleList.push({
                id: vehicleDoc.id,
                fuelType: vehicleDocData?.data?.fuelType,
                gearboxType: vehicleDocData?.data?.gearboxType,
                mileage: vehicleDocData?.data?.mileage,
                mainImageSrc: '',
              });
            }
          });

          this.publicVehicleList = publicVehicleList;
        }, (error) => {
          console.error(error);
        });
    },
  },
  beforeDestroy() {
    if (typeof this.unsubVehicleFilters === 'function') this.unsubVehicleFilters();
    if (typeof this.unsubPublicVehicleListing === 'function') this.unsubPublicVehicleListing();
  },
};
</script>


<style scoped>
.container {
  background-image: url('/images/autodrop/welcome-bg02.jpg');
}

.items-container {
  background: rgba(0, 0, 0, 0.8);
}

.grid-vehicle-list {
  display: grid;
  grid-gap: theme('spacing.20');
  grid-template-columns: repeat(auto-fit, auto);
}

.grid-vehicle-card {
  @apply grid;

  grid-template-rows: 120px;
  grid-template-columns: 120px auto;
}


@screen mobile-m {
  .grid-vehicle-list {
    grid-template-columns: repeat(auto-fit, auto);
  }

  .grid-vehicle-card {
    grid-template-rows: 150px;
    grid-template-columns: 150px auto;
  }
}

@screen mobile-l {
  .grid-vehicle-list {
    grid-template-columns: repeat(auto-fit, 320px);
  }
}

@screen laptop {
  .grid-vehicle-list {
    grid-template-columns: repeat(auto-fit, 350px);
  }

  .grid-vehicle-card {
    grid-template-rows: 170px;
    grid-template-columns: 170px auto;
  }
}
</style>
